import {
  GetExtractObservationDetailsActionTypes,
  GET_EXTRACT_OBSERVATION_FAIL,
  GET_EXTRACT_OBSERVATION_LOADING,
  GET_EXTRACT_OBSERVATION_SUCCESS,
  GetExtractObservationState,
  GET_EXTRACT_OBSERVATION_API_MSG,
  GET_EXTRACT_OBSERVATION_API_RES,
} from "./ActionTypes";
import { GetExtractObservationDetailsRes } from "./Model";

const initialStateUpdatePosts: GetExtractObservationState = {
  loading: false,
  getExtractObservationRes: {} as GetExtractObservationDetailsRes,
  errorMsg: "",
  status: 0,
};
export const GetExtractObservationByDetailsIdReducer = (
  state = initialStateUpdatePosts,
  action: GetExtractObservationDetailsActionTypes
): GetExtractObservationState => {
  switch (action.type) {
    case GET_EXTRACT_OBSERVATION_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case GET_EXTRACT_OBSERVATION_SUCCESS:
      return {
        ...state,
        getExtractObservationRes: action.payload,
      };
    case GET_EXTRACT_OBSERVATION_FAIL:
      return {
        ...state,
        getExtractObservationRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_EXTRACT_OBSERVATION_API_MSG:
      return {
        ...state,
        getExtractObservationRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_EXTRACT_OBSERVATION_API_RES:
      return {
        ...state,
        getExtractObservationRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
